import { useParams } from "react-router-dom";
import TrainingView from "./../components/TrainingView.react";

export default function TrainingViewRoute(): React$Element<any> {
  let params = useParams();
  return <TrainingView sessionId={params.sessionId} />;
}
